var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"input-group\">\n<input class=\"form-control\" ng-model=\"model[options.key]\"/>\n<span class=\"input-group-btn\">\n<button class=\"btn btn-default addonssingleselect\" ng-click=\"model[options.key] = null\"><i class=\"fa fa-times\"></i></button>\n</span>\n</div>";
var id1="bssdatetime.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;